import {
  FETCH_EXPIRYRETURNDETAILS_SUCCESS_ACTION,
  FETCH_EXPIRYRETURNVIEW_SUCCESS_ACTION,
  UPDATE_EXPIRY_APPROVED_QTY_SUCCESS,
} from "./action";

const initialState = {
  processing: false,
  error: false,
  ExpiryReturnsDetails: [],
  ExpiryReturnsCount: 0,
  ExpiryReturnDtls: [],
  ItemCount: 0,
};

export default function ExpiryReturnsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_EXPIRYRETURNDETAILS_SUCCESS_ACTION:
      return {
        ...state,
        ExpiryReturnsDetails: action.payload.rows,
        ExpiryReturnsCount: action.payload.count,
      };

    case FETCH_EXPIRYRETURNVIEW_SUCCESS_ACTION:
      return {
        ...state,
        ExpiryReturnDtls: action.payload.rows,
        ItemCount: action.payload.count,
      };

    case UPDATE_EXPIRY_APPROVED_QTY_SUCCESS:
      return {
        ...state,
        ExpiryReturnDtls: state.ExpiryReturnDtls.map((item) =>
          item.id === action.payload.id
            ? {
              ...item,
              approvedQntty: action.payload.approvedQntty,
              approvedAmount: action.payload.approvedAmount,
            }
            : item
        ),
      };

    default:
      return state;
  }
}
